import React from 'react';
import cn from 'classnames';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';
import Typography from 'brandComponents/Typography';

import {useAccordionGroup} from '../context/AccordionGroupContext';

import {IAccordionItemProps} from './IAccordionGroupItem';

import styles from './AccordionGroupItem.module.scss';

const AccordionGroupItem = ({
	classNames,
	title,
	content,
	disableTriggerButton = false,
}: IAccordionItemProps) => {
	const {hTag, handleClick, isActive, expandIcon, collapseIcon} = useAccordionGroup();
	const iconName = isActive ? expandIcon : collapseIcon;

	return title && content ? (
		<div className={cn('accordion', classNames, styles['accordion_group'], {active: isActive})}>
			<Button
				onClick={!disableTriggerButton ? handleClick : null}
				classNames="accordion-title" contentClassNames="accordion-title-content"
			>
				{hTag !== 'span' ? (
					<Typography variant={hTag} classNames="accordion-title-text">
						{title}
					</Typography>
				) : (
					<div className="accordion-title-text">{title}</div>
				)}

				<Icon name={iconName} classNames="accordion-icon" width={20} height={20} />
			</Button>
			<div className={cn('accordion-content', isActive ? 'active' : 'inactive')}>{content}</div>
		</div>
	) : null;
};

export default AccordionGroupItem;
